"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStencilPXTTelemetryPortalPatch = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _pxtTelemetryClient = require("./pxtTelemetryClient");
var useStencilPXTTelemetryPortalPatch = function useStencilPXTTelemetryPortalPatch() {
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pxtTelemetryPath = _useState2[0],
    setPxtTelemetryPath = _useState2[1];
  var pxtTelemetryTargetRef = (0, _react.useCallback)(function (node) {
    //@ts-ignore
    if (node !== null && window && !!window.PxtTelemetry) {
      var telemetryClient = _pxtTelemetryClient.PXTTelemetryClient.getInstance('');
      var dataPxtTelemetryPath = telemetryClient.reactPortalTelemetryCompatibilityPatch(node);
      setPxtTelemetryPath(dataPxtTelemetryPath);
    }
  }, []);
  return [pxtTelemetryPath, pxtTelemetryTargetRef];
};
exports.useStencilPXTTelemetryPortalPatch = useStencilPXTTelemetryPortalPatch;